import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../constants/colors';
import { desktopMinWidth } from '../../../utils/windowHelpers';
import { Helmet } from 'react-helmet-async';
import HeaderV2 from '../../components/HeaderV2';
import Page from '../Page';
import LogoWithCircle from '../../components/icons/LogoWithCircle';
import Footer from '../../components/Footer';
import BackArrow from '../../components/icons/BackArrow';
import { Link } from 'react-router-dom';
import Details from './components/Details';
import Attributes from './components/Attributes';
import Loading from '../../components/Loading';
import ShareVia from './components/ShareVia';
import OpenseaIcon from '../../components/icons/SocialIcons/OpenseaIcon';
import DiscordIcon from '../../components/icons/SocialIcons/DiscordIcon';
import { Button, Dialog } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useConnectWallet } from 'app/contexts/ConnectWalletContext';
import { TOKEN_PAGE_CLAIM_CONST } from './constants';
import { getNftData, getNftStatus } from 'app/services/nftDetailService';
import Modal from 'app/components/Modal';
import { minDesktopWidth } from 'utils/domHelpers';

const BENYU_MASTER_NFTS_COURSE = 'How To Master NFTs in 7 Days';

export const TokenDetailPage = () => {
  const useStyles = makeStyles(theme =>
    createStyles({
      root: {
        background: colors.darker_blue,
      },
      container: {
        margin: '64px 24px 80px 24px',
        minHeight: 700,
        position: 'relative',
        [desktopMinWidth]: {
          margin: '64px auto 120px auto',
        },
        '& a': {
          textDecoration: 'none',
        },
        fontFamily: 'Poppins',
      },
      flexContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        [desktopMinWidth]: {
          flexDirection: 'row',
        },
      },
      leftContainer: {
        [desktopMinWidth]: {
          marginRight: 80,
        },
      },
      img: {
        borderRadius: 4,
        width: 180,
        height: 295,
        [desktopMinWidth]: {
          width: 338,
          height: 520,
        },
      },
      rightContainer: {},
      backContainer: {
        color: colors.white_f2,
        display: 'flex',
        fontSize: 14,
        marginBottom: 32,
        cursor: 'pointer',
        [desktopMinWidth]: {
          fontSize: 16,
          marginBottom: 40,
        },
      },
      backLogo: {
        marginRight: 8,
        paddingTop: 2,
      },
      title: {
        color: colors.white_f2,
        marginBottom: 8,
        fontWeight: 500,
        marginTop: 32,
        fontSize: 28,
        [desktopMinWidth]: {
          fontSize: 32,
          maxWidth: 400,
          marginTop: 0,
        },
      },
      createdBy: {
        color: colors.white_f2,
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        [desktopMinWidth]: {
          fontSize: 16,
        },
      },
      logo: {
        marginRight: 8,
      },
      descriptionContainer: {
        margin: '32px 0',
        [desktopMinWidth]: {
          margin: '40px 0',
        },
      },
      label: {
        fontSize: 12,
        color: colors.gray_aa,
        marginBottom: 8,
        [desktopMinWidth]: {
          fontSize: 14,
        },
      },
      description: {
        fontSize: 14,
        color: colors.white_f2,
        fontWeight: 400,
        [desktopMinWidth]: {
          fontSize: 16,
          maxWidth: 400,
        },
      },
      detailContainer: {
        marginTop: 24,
      },
      attributeContainer: {
        marginTop: 24,
      },
      disclaimer: {
        fontSize: 12,
        color: colors.gray_66,
        marginTop: 24,
      },
      errorTitle: {
        fontSize: 14,
        color: colors.white_f2,
        margin: '0 auto',
        maxWidth: 200,
        textAlign: 'center',
        [desktopMinWidth]: {
          fontSize: 16,
          fontWeight: 500,
          maxWidth: 220,
        },
      },
      openseaLinkContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 24,
        '& a': {
          fontSize: 14,
          color: colors.white_f2,
          textDecoration: 'none',
          paddingBottom: 4,
        },
      },
      benefitContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 24,
        cursor: 'pointer',
      },
      benefitText: {
        fontSize: 14,
        color: colors.brand_yellow,
        textDecoration: 'none',
        paddingBottom: 4,
      },
      openseaIcon: {
        marginRight: 8,
      },
      warningLabel: {
        marginTop: 12,
        color: colors.white_f2,
        fontSize: 12,
        maxWidth: 320,
        [desktopMinWidth]: {
          maxWidth: 360,
        },
      },
      modal: {
        padding: '20px 12px',
        [desktopMinWidth]: {
          padding: '20px 24px',
        },
      },
      dialog: {
        position: 'relative',
        '& .MuiDialog-paper': {
          margin: '32px 16px !important',
          [desktopMinWidth]: {
            margin: '32px',
          },
        },
      },
      modalHeader: {
        color: colors.black,
        fontWeight: 600,
        marginBottom: 8,
        fontSize: 18,
        marginTop: 12,
        [desktopMinWidth]: {
          fontSize: 22,
        },
      },
      modalSubheader: {
        color: colors.gray_66,
        marginBottom: 24,
        fontSize: 16,
        maxWidth: 312,
        [desktopMinWidth]: {
          marginBottom: 32,
          maxWidth: 440,
        },
      },
      closeIcon: {
        top: 10,
        right: 20,
        position: 'absolute',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.7,
        },
      },
      videoContainer: {
        width: 280,
        marginBottom: 32,
        [desktopMinWidth]: {
          width: 450,
        },
      },
      accessBtn: {
        width: 180,
        margin: '0 auto',
        '& a': {
          color: colors.black_33,
          fontSize: 14,
        },
      },
      claimModal: {
        width: '100%',
        [minDesktopWidth]: {
          width: 320,
          padding: '40px 16px',
        },
      },
      claimModalTitle: {
        margin: 0,
        fontSize: 24,
        fontWeight: 500,
        color: '#333',
        marginBottom: 12,

        [minDesktopWidth]: {
          fontSize: 18,
        },
      },
      claimModalDesc: {
        margin: 0,
        fontSize: 16,
        color: '#666',
        marginBottom: 24,
      },
      claimModalFooter: {
        margin: 0,
        fontSize: 14,
        color: '#666',
      },
      claimModalFooterBold: {
        fontSize: 16,
        fontWeight: 500,
        color: '#333',
        marginLeft: 16,
      },
    }),
  );

  const classes = useStyles();

  //get params from the url
  const urlParams: { contractAddress: string; tokenId: string } = useParams();
  const contractAddress = urlParams?.contractAddress;
  const tokenId = urlParams?.tokenId;

  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  const isNftClaimFlow = queryParams?.get('type') === TOKEN_PAGE_CLAIM_CONST;

  const { onConnectClick, setNftClaiDetails } = useConnectWallet();

  const [loadingToken, setLoadingToken] = useState<boolean>(false);
  const [token, setToken] = useState(null);
  const [tokenStatusData, setTokenStatusData] = useState();
  const [tokenError, setTokenError] = useState<string | null>();
  const [isNotClaimedModalOpen, setIsNotClaimedModalOpen] = useState<boolean>(
    false,
  );
  const [openBenefit, setOpenBenefit] = useState<boolean>(false);

  // @ts-ignore
  const userEmail = tokenStatusData?.learnerEmail;
  // @ts-ignore
  const { attributes, image, description } = token?.metadata || {};
  const courseNameObj = attributes?.find(
    attribute => attribute?.trait_type === 'Course Name',
  );
  const courseName = courseNameObj?.value;
  const mintImage = image?.includes('https')
    ? image
    : image?.includes('ipfs://')
    ? `${process.env.REACT_APP_IPFS_BASE_URL}/${image.split('ipfs://')[1]}`
    : `${process.env.REACT_APP_IPFS_BASE_URL}/${image}`;

  const getTokenDetails = useCallback(
    async ({ contractAddress, tokenId }) => {
      setTokenError(null);
      setLoadingToken(true);

      try {
        setNftClaiDetails?.({ tokenId, contractAddress });

        const { data, error } = await getNftData({
          contractAdd: contractAddress,
          tokenId,
        });

        //@ts-ignore
        if (error) throw new Error(error);

        setToken(data);

        if (isNftClaimFlow) {
          //check its a claim flow
          onConnectClick?.({ modalsNotClosable: true, claimNftFlow: true });
          return;
        }

        //check status of the nft
        const { data: statusData, error: statusError } = await getNftStatus({
          contractAddress,
          tokenId,
        });

        //@ts-ignore
        if (statusError) throw new Error(statusError);

        const isNotClaimedYet = statusData.status === 'pending';
        setTokenStatusData(statusData);

        if (isNotClaimedYet) setIsNotClaimedModalOpen(true);
      } catch (error) {
        if (error instanceof Error) setTokenError(error.message);
      } finally {
        setLoadingToken(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isNftClaimFlow],
  );

  useEffect(() => {
    getTokenDetails({ contractAddress, tokenId });
  }, [contractAddress, getTokenDetails, tokenId]);

  return (
    <div>
      <div className={classes.root}>
        <Helmet>
          <title>NFT Token Details</title>
          <meta name="title" content="NFT Token Details" />
          <meta
            name="description"
            content="Empowering Education using Web3/Blockchain technology. We are the technology arm of Nas Academy, whose mission is to create the world's best learning communities."
          />
          <meta
            property="og:image"
            content="https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/lesan/nasio/nasio_cover.png"
          />
          <meta
            property="og:url"
            content={`${process.env.REACT_APP_FRONTEND_URL}/details/${contractAddress}/${tokenId}`}
          />
        </Helmet>
        <HeaderV2 showNavlinks={true} headerTheme="blue" showLogin={false} />
        <Page>
          <div className={classes.container}>
            {loadingToken && <Loading />}
            {attributes && !loadingToken && (
              <>
                <Link to={`/tokens`}>
                  <div className={classes.backContainer}>
                    <div className={classes.backLogo}>
                      <BackArrow />
                    </div>
                    Back to My NFTs
                  </div>
                </Link>
                <div className={classes.flexContainer}>
                  <div className={classes.leftContainer}>
                    <img
                      src={mintImage}
                      className={classes.img}
                      alt="certificate"
                    />
                    <div className={classes.openseaLinkContainer}>
                      <div className={classes.openseaIcon}>
                        <OpenseaIcon />
                      </div>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${process.env.REACT_APP_OPENSEA_BASE_URL}/${contractAddress}/${tokenId}`}
                      >
                        View on OpenSea
                      </a>
                    </div>
                    <div className={classes.warningLabel}>
                      *Note that this NFT is not tradeable/transferable. All
                      trading transactions for this NFT on OpenSea will not go
                      through.
                    </div>
                    {courseName.includes(BENYU_MASTER_NFTS_COURSE) && (
                      <div
                        className={classes.benefitContainer}
                        onClick={() => setOpenBenefit(true)}
                      >
                        <div className={classes.openseaIcon}>
                          <DiscordIcon color={colors.brand_yellow} />
                        </div>
                        <div className={classes.benefitText}>
                          Get your graduation benefit
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={classes.rightContainer}>
                    <div className={classes.title}>
                      {courseName} #{tokenId}
                    </div>
                    <div className={classes.createdBy}>
                      <div className={classes.logo}>
                        <LogoWithCircle />
                      </div>
                      <span>Created by </span>
                      <span
                        style={{ textDecoration: 'underline', marginLeft: 5 }}
                      >
                        nasacademy
                      </span>
                    </div>
                    <ShareVia
                      tokenId={tokenId}
                      contractAddress={contractAddress}
                      token={token}
                    />
                    <div className={classes.descriptionContainer}>
                      <div className={classes.label}>Description</div>
                      <div className={classes.description}>{description}</div>
                    </div>
                    <div className={classes.attributeContainer}>
                      <Attributes attributes={attributes} />
                    </div>
                    <div className={classes.detailContainer}>
                      <Details
                        tokenId={tokenId}
                        contractAddress={contractAddress}
                      />
                    </div>
                    <div className={classes.disclaimer}>
                      *Certificate tokens are not transferable
                    </div>
                  </div>
                </div>
                <Dialog open={openBenefit}>
                  <div
                    onClick={() => setOpenBenefit(false)}
                    className={classes.closeIcon}
                  >
                    <CloseIcon
                      style={{
                        color: colors.gray_aa,
                        width: 22,
                        height: 22,
                      }}
                    />
                  </div>
                  <div className={classes.modal}>
                    <div className={classes.modalHeader}>
                      Curious Addy Trading Club Discord Access
                    </div>
                    <div className={classes.modalSubheader}>
                      With the NFT Certificate token, you can now become premium
                      member of the CATC Discord channel, with priority access
                      to Q&A service. Watch instruction video below for details.
                    </div>
                    <div>
                      <video controls={true} className={classes.videoContainer}>
                        <source
                          type="video/mp4"
                          src="https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/curious_addy_benefit.mp4"
                        />
                      </video>
                    </div>
                    <div className={classes.accessBtn}>
                      <Button variant="contained" color="primary">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://discord.com/invite/catc"
                        >
                          Access Discord
                        </a>
                      </Button>
                    </div>
                  </div>
                </Dialog>
              </>
            )}
          </div>
          <Footer blueTheme={true} />
        </Page>
      </div>
      <Modal open={!!tokenError} onClose={() => {}} showCloseIcon={false}>
        <div>{tokenError}</div>
      </Modal>
      <Modal
        open={isNotClaimedModalOpen}
        onClose={() => {}}
        showCloseIcon={false}
        customContainerClass={classes.claimModal}
      >
        <div>
          <p className={classes.claimModalTitle}>
            Certificate has not been claimed
          </p>
          <p className={classes.claimModalDesc}>
            Please check your email for instructions to claim the certificate.
            The email has sent to the below email address.
          </p>
          <p className={classes.claimModalFooter}>
            Email
            <span className={classes.claimModalFooterBold}>{userEmail}</span>
          </p>
        </div>
      </Modal>
    </div>
  );
};
